import * as React from 'react';
import {connect} from 'react-redux';
import {Button} from '@material-ui/core';

import {updateSlideElement} from 'client/actions/slideShowEditor';
import EditorTextarea from '../formFields/EditorTextarea';
import EditorActionButtonsCommon from '../formFields/EditorActionButtonsCommon';
import {ISlideElement, SlideElementLogoPositionEnum} from 'shared/collections/SlideElements';
import {LL} from 'shared/localization';
import {RootState} from 'client/store/root-reducer';
import EditorDelimiter from '../formFields/EditorDelimiter';
import BgColorField from '../settingsFields/BgColorField';
import BgImageField from '../settingsFields/BgImageField';
import OpacityField from '../settingsFields/OpacityField';
import PermanentElementField from '../settingsFields/PermanentElementField';
import ElementSettingsWrapper from 'client/components/common/ElementSettingsWrapper';
import EditorSelect from 'client/components/editor/formFields/EditorSelect';
import routerUrls from 'client/constants/routerUrls';
import RotateAngleField from 'client/components/editor/settingsFields/RotateAngleField';

import TextAreaField from 'client/components/editor/settingsFields/TextAreaField';
import EditorImage from 'client/components/editor/formFields/EditorImage';

interface IHtmlElementSettingsProps {
	slideshowId: string;
	element: ISlideElement;
	updateSlideElement: typeof updateSlideElement;
}

class HtmlElementSettings extends React.PureComponent<IHtmlElementSettingsProps> {
	handleHtmlChange = (value: string) => {
		const {element} = this.props;

		this.props.updateSlideElement(element, {html: value});
	};

	handleHtmlUpdateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const {element} = this.props;
		const {value} = event.target;

		this.props.updateSlideElement(element, {htmlUpdate: Number(value)});
	};

	handleLogoImageChange = (image: string) => {
		const {element} = this.props;
		this.props.updateSlideElement(element, {videoLogo: image});
	};

	handleLogoPositionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const {element} = this.props;

		this.props.updateSlideElement(element, {
			logoPosition: event.target.value,
		});
	};

	render() {
		const {element} = this.props;

		return (
			<ElementSettingsWrapper elementId={element._id}>
				<TextAreaField
					label="Код HTML"
					tooltip={'Вставьте код информера'}
					value={element.html}
					helpText={
						<Button
							variant="contained"
							color="primary"
							fullWidth
							size="small"
							href={routerUrls.extInformers}
							target="_blank"
						>
							Информеры
						</Button>
					}
					onChange={this.handleHtmlChange}
				/>

				<EditorSelect
					label="Обновлять"
					tooltip="Принудительное обновление"
					options={[
						{label: 'Никогда', value: 0},
						{label: 'Раз в час', value: 1},
						{label: 'Раз в три часа', value: 3},
						{label: 'Раз в шесть часов', value: 6},
						{label: 'Раз в двенадцать часов', value: 12},
						{label: 'Раз в сутки', value: 24},
					]}
					onChange={this.handleHtmlUpdateChange}
					value={element.htmlUpdate || 0}
				/>

				<BgColorField element={element} />
				<BgImageField element={element} />
				<EditorImage
					label={LL('editor.element.logoCorner')}
					value={element.videoLogo}
					onChange={this.handleLogoImageChange}
				/>
				{element.videoLogo && (
					<EditorSelect
						label={LL('editor.element.logoLocation')}
						options={[
							{
								label: LL('editor.element.topLeftCorner'),
								value: SlideElementLogoPositionEnum.TOPLEFT,
							},
							{
								label: LL('editor.element.topRightCorner'),
								value: SlideElementLogoPositionEnum.TOPRIGHT,
							},
							{
								label: LL('editor.element.bottomLeftCorner'),
								value: SlideElementLogoPositionEnum.BOTTOMLEFT,
							},
							{
								label: LL('editor.element.bottomRightCorner'),
								value: SlideElementLogoPositionEnum.BOTTOMRIGHT,
							},
						]}
						onChange={this.handleLogoPositionChange}
						value={element.logoPosition}
					/>
				)}
				<RotateAngleField element={element} />
				<OpacityField element={element} />
				<PermanentElementField element={element} />

				<EditorDelimiter />

				<EditorActionButtonsCommon element={element} />
			</ElementSettingsWrapper>
		);
	}
}

export default connect(
	(state: RootState) => ({
		slideshowId: state.slideShowEditor.slideshowId,
	}),
	{updateSlideElement},
)(HtmlElementSettings);
